// removed by extract-text-webpack-plugin
module.exports = {"unit":"5px","shadeDisabled":"rgb(205, 204, 204)","colorPrimaryOrange":"#e16e46","container":"competency-bars__container____1AIRP"};


//////////////////
// WEBPACK FOOTER
// ./src/ui/components/competency-bars/competency-bars.css
// module id = 122
// module chunks = 0